<template>
    <div class="rounded-lg py-2 px-1">
        <div class="space-y-4">
            <p class="text-xs md:text-sm">
                As you are signing up to this direct debit online and you are not signing a paper mandate you authorise
                (A) One Direct (Ireland) Ltd trading as An Post Insurance to send instructions to your bank to debit
                your account and (B) your bank to debit your account in accordance with the instructions from An Post
                Insurance.
            </p>
            <p class="text-xs md:text-sm">
                As part of your rights, you are entitled to a refund from your bank under the terms and conditions of
                your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which
                your account was debited. Your rights regarding the above mandate are explained in a statement that you
                can obtain from your bank.
            </p>
            <div class="py-4 border-y-2 border-grey-200">
                <asli-checkbox
                    v-model="agreedToTerms"
                    class="mb-3"
                    label="I agree to the terms and conditions of the direct debit above."
                    name="agreed_to_terms"
                    id="agreed_to_terms"
                    rules="required"
                    checkbox-size="w-7 h-7"
                    text-size="text-xs"
                />
                <asli-checkbox
                    v-model="confirmedAuthorization"
                    label="I confirm that I am the only person whose authorisation is required for debits from this account."
                    name="confirmed_authorization"
                    id="confirmed_authorization"
                    rules="required"
                    checkbox-size="w-7 h-7"
                    text-size="text-xs"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { AsliCheckbox } from "@mbs-npm/anpost-ui";
import { ref, watch } from "vue";

const agreedToTerms = ref(false);
const confirmedAuthorization = ref(false);

const emit = defineEmits(["agreedConfirmed"]);

watch([agreedToTerms, confirmedAuthorization], ([agreedVal, confirmedVal]) => {
    emit("agreedConfirmed", agreedVal && confirmedVal);
});
</script>
